// extracted by mini-css-extract-plugin
export default {"button":"Pk-z","reviewSort":"Qk-z"};